import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "time-recoder" }
const _hoisted_2 = { class: "text-2xl font-bold" }
const _hoisted_3 = { class: "box-time-recoder__information py-8" }
const _hoisted_4 = { class: "organization-code mb-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "mr-8" }, ":", -1)
const _hoisted_6 = { class: "organization-name" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "mr-8" }, ":", -1)
const _hoisted_8 = { class: "time-recoder__table" }
const _hoisted_9 = { class: "heading-table mb-4" }
const _hoisted_10 = { class: "flex items-center w-full" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "flex items-center w-full" }
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = { class: "flex items-center w-full" }
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = { class: "flex items-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_Table = _resolveComponent("Table")
  const _component_PlusIcon = _resolveComponent("PlusIcon")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BackPreviousPage, { onClick: _ctx.returnScreen }, null, 8, ["onClick"]),
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('timeClockSettings')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.t('approvedSetting.organizationCode')) + " ", 1),
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.timeCoderId), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.t('approvedSetting.organizationName')) + " ", 1),
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_ctx.timeCoderName), 1)
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, _toDisplayString(_ctx.t('settingTimeRecoder.usagePermissionSetting')), 1),
      _createVNode(_component_Table, {
        headers: _ctx.timeRecoderHeader,
        data: _ctx.apiPostTimeRecoder.time_recorder_details,
        class: "w-fit text-sm text-center"
      }, {
        type_of_work_form_define_name: _withCtx(({ item }) => [
          _createVNode("div", null, [
            _createVNode("div", null, _toDisplayString(item.type_of_work_form_define_name
                  ? item.type_of_work_form_define_name
                  : _ctx.handleTypeOfWorkingStyleDefines(
                      item.type_of_work_form_define_id
                    )), 1)
          ])
        ]),
        is_browser_stamping: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_RadioGroup, {
                "options-radio": _ctx.statusRecoderList,
                modelValue: item.is_browser_stamping,
                "onUpdate:modelValue": ($event: any) => (item.is_browser_stamping = $event)
              }, null, 8, ["options-radio", "modelValue", "onUpdate:modelValue"])
            ])
          ])
        ]),
        is_ic_card_check_time: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_RadioGroup, {
                "options-radio": _ctx.statusRecoderList,
                modelValue: item.is_ic_card_check_time,
                "onUpdate:modelValue": ($event: any) => (item.is_ic_card_check_time = $event)
              }, null, 8, ["options-radio", "modelValue", "onUpdate:modelValue"])
            ])
          ])
        ]),
        is_face_recognition_stamping: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_RadioGroup, {
                "options-radio": _ctx.statusRecoderList,
                modelValue: item.is_face_recognition_stamping,
                "onUpdate:modelValue": ($event: any) => (item.is_face_recognition_stamping = $event)
              }, null, 8, ["options-radio", "modelValue", "onUpdate:modelValue"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode(_component_Button, {
        class: "mr-4",
        onClick: _ctx.handleNavigationTimeRecoder
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PlusIcon, { class: "mr-1 items-center" }),
          _createTextVNode(_toDisplayString(_ctx.t('approvedFlow.toRegister')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}